<script lang="ts">
	import Banner from '../../lib/components/Banner.svelte';
	import { storyblokEditable } from '@storyblok/svelte';
	import Cookies from 'js-cookie';

	export let props;

	props.closeAction = () => {
		Cookies.set('ws-close-cms-banner', 'true', {
			expires: 1
		});
	};
</script>

<div use:storyblokEditable={props}>
	<Banner {props} />
</div>
